module.exports = __webpack_public_path__ + "static/media/nszu.ac5f0715.svg";